"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSelectedVariant = exports.updateSelectedRelationshipProduct = exports.updateSelectedPlan = exports.updateSelectedHandset = exports.updateSelectedBusinessSolution = exports.updateSelectedBroadband = exports.unsetRecommendation = exports.setRecommendationSteps = exports.setRecommendation = exports.setRawRecommendation = exports.goToUpsellPage = exports.goToPreviousStep = exports.goToNextStep = exports.goToComparisonPage = exports.goBackToQuestionnaire = exports.fetchRecommendation = exports.UPDATE_SELECTED_VARIANT = exports.UPDATE_SELECTED_RELATIONSHIP_PRODUCT = exports.UPDATE_SELECTED_PLAN = exports.UPDATE_SELECTED_HANDSET = exports.UPDATE_SELECTED_BUSINESS_SOLUTION = exports.UPDATE_SELECTED_BROADBAND = exports.UNSET_RECOMMENDATION = exports.SET_STEPS = exports.SET_RECOMMENDATION = exports.SET_RAW_RECOMMENDATION = exports.GO_TO_UPSELL_PAGE = exports.GO_TO_PREVIOUS_STEP = exports.GO_TO_NEXT_STEP = exports.GO_TO_COMPARISON_PAGE = exports.GO_BACK_TO_QUESTIONNAIRE = exports.FETCH_RECOMMENDATION_SUCCESS = exports.FETCH_RECOMMENDATION = void 0;
var FETCH_RECOMMENDATION = 'FETCH_RECOMMENDATION';
exports.FETCH_RECOMMENDATION = FETCH_RECOMMENDATION;
var FETCH_RECOMMENDATION_SUCCESS = 'FETCH_RECOMMENDATION_SUCCESS';
exports.FETCH_RECOMMENDATION_SUCCESS = FETCH_RECOMMENDATION_SUCCESS;
var SET_RECOMMENDATION = 'SET_RECOMMENDATION';
exports.SET_RECOMMENDATION = SET_RECOMMENDATION;
var SET_RAW_RECOMMENDATION = 'SET_RAW_RECOMMENDATION';
exports.SET_RAW_RECOMMENDATION = SET_RAW_RECOMMENDATION;
var UNSET_RECOMMENDATION = 'UNSET_RECOMMENDATION';
exports.UNSET_RECOMMENDATION = UNSET_RECOMMENDATION;
var GO_BACK_TO_QUESTIONNAIRE = 'GO_BACK_TO_QUESTIONNAIRE';
exports.GO_BACK_TO_QUESTIONNAIRE = GO_BACK_TO_QUESTIONNAIRE;
var GO_TO_UPSELL_PAGE = 'GO_TO_UPSELL_PAGE';
exports.GO_TO_UPSELL_PAGE = GO_TO_UPSELL_PAGE;
var GO_TO_COMPARISON_PAGE = 'GO_TO_COMPARISON_PAGE';
exports.GO_TO_COMPARISON_PAGE = GO_TO_COMPARISON_PAGE;
var UPDATE_SELECTED_HANDSET = 'UPDATE_SELECTED_HANDSET';
exports.UPDATE_SELECTED_HANDSET = UPDATE_SELECTED_HANDSET;
var UPDATE_SELECTED_PLAN = 'UPDATE_SELECTED_PLAN';
exports.UPDATE_SELECTED_PLAN = UPDATE_SELECTED_PLAN;
var UPDATE_SELECTED_BROADBAND = 'UPDATE_SELECTED_BROADBAND';
exports.UPDATE_SELECTED_BROADBAND = UPDATE_SELECTED_BROADBAND;
var UPDATE_SELECTED_BUSINESS_SOLUTION = 'UPDATE_SELECTED_BUSINESS_SOLUTION';
exports.UPDATE_SELECTED_BUSINESS_SOLUTION = UPDATE_SELECTED_BUSINESS_SOLUTION;
var UPDATE_SELECTED_VARIANT = 'UPDATE_SELECTED_VARIANT';
exports.UPDATE_SELECTED_VARIANT = UPDATE_SELECTED_VARIANT;
var UPDATE_SELECTED_RELATIONSHIP_PRODUCT = 'UPDATE_SELECTED_RELATIONSHIP_PRODUCT';
exports.UPDATE_SELECTED_RELATIONSHIP_PRODUCT = UPDATE_SELECTED_RELATIONSHIP_PRODUCT;
var SET_STEPS = 'SET_STEPS';
exports.SET_STEPS = SET_STEPS;
var GO_TO_NEXT_STEP = 'GO_TO_NEXT_STEP';
exports.GO_TO_NEXT_STEP = GO_TO_NEXT_STEP;
var GO_TO_PREVIOUS_STEP = 'GO_TO_PREVIOUS_STEP';
exports.GO_TO_PREVIOUS_STEP = GO_TO_PREVIOUS_STEP;
var fetchRecommendation = function fetchRecommendation() {
  return {
    type: FETCH_RECOMMENDATION
  };
};
exports.fetchRecommendation = fetchRecommendation;
var setRawRecommendation = function setRawRecommendation(recommendationResponse) {
  return {
    type: SET_RAW_RECOMMENDATION,
    payload: {
      recommendationResponse: recommendationResponse
    }
  };
};
exports.setRawRecommendation = setRawRecommendation;
var setRecommendation = function setRecommendation(recommendationData) {
  return {
    type: SET_RECOMMENDATION,
    payload: {
      recommendationData: recommendationData
    }
  };
};
exports.setRecommendation = setRecommendation;
var unsetRecommendation = function unsetRecommendation() {
  return {
    type: UNSET_RECOMMENDATION
  };
};
exports.unsetRecommendation = unsetRecommendation;
var goBackToQuestionnaire = function goBackToQuestionnaire() {
  return {
    type: GO_BACK_TO_QUESTIONNAIRE
  };
};
exports.goBackToQuestionnaire = goBackToQuestionnaire;
var goToUpsellPage = function goToUpsellPage() {
  return {
    type: GO_TO_UPSELL_PAGE
  };
};
exports.goToUpsellPage = goToUpsellPage;
var goToComparisonPage = function goToComparisonPage() {
  return {
    type: GO_TO_COMPARISON_PAGE
  };
};
exports.goToComparisonPage = goToComparisonPage;
var updateSelectedHandset = function updateSelectedHandset(productId) {
  return {
    type: UPDATE_SELECTED_HANDSET,
    payload: {
      productId: productId
    }
  };
};
exports.updateSelectedHandset = updateSelectedHandset;
var updateSelectedPlan = function updateSelectedPlan(productId) {
  return {
    type: UPDATE_SELECTED_PLAN,
    payload: {
      productId: productId
    }
  };
};
exports.updateSelectedPlan = updateSelectedPlan;
var updateSelectedBroadband = function updateSelectedBroadband(productId) {
  return {
    type: UPDATE_SELECTED_BROADBAND,
    payload: {
      productId: productId
    }
  };
};
exports.updateSelectedBroadband = updateSelectedBroadband;
var updateSelectedBusinessSolution = function updateSelectedBusinessSolution(productId) {
  return {
    type: UPDATE_SELECTED_BUSINESS_SOLUTION,
    payload: {
      productId: productId
    }
  };
};
exports.updateSelectedBusinessSolution = updateSelectedBusinessSolution;
var updateSelectedVariant = function updateSelectedVariant(productId, variantId) {
  return {
    type: UPDATE_SELECTED_VARIANT,
    payload: {
      productId: productId,
      variantId: variantId
    }
  };
};
exports.updateSelectedVariant = updateSelectedVariant;
var updateSelectedRelationshipProduct = function updateSelectedRelationshipProduct(offering) {
  return {
    type: UPDATE_SELECTED_RELATIONSHIP_PRODUCT,
    payload: {
      offering: offering
    }
  };
};
exports.updateSelectedRelationshipProduct = updateSelectedRelationshipProduct;
var setRecommendationSteps = function setRecommendationSteps(steps) {
  return {
    type: SET_STEPS,
    payload: {
      steps: steps
    }
  };
};
exports.setRecommendationSteps = setRecommendationSteps;
var goToNextStep = function goToNextStep() {
  return {
    type: GO_TO_NEXT_STEP
  };
};
exports.goToNextStep = goToNextStep;
var goToPreviousStep = function goToPreviousStep() {
  return {
    type: GO_TO_PREVIOUS_STEP
  };
};
exports.goToPreviousStep = goToPreviousStep;